module.exports = "/assets/data/95eff815384904a11f6be7c6fdefbaf9-DL15.data.json";